import { Component, Input } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-processing-banner',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './processing-banner.component.html',
  styleUrl: './processing-banner.component.scss',
})
export class ProcessingBannerComponent {
  displayText: string = 'Text Here';
  @Input()
  set WaitMessage(value: string) {
    this.displayText = value;
  }
}
